import Button from '@zenbusiness/zui/Button';
import Container from '@zenbusiness/zui/Container';
import { superstyled } from '@zenbusiness/zui/styles';

export const CheckoutContainer = superstyled({
  tag: Container,
  name: 'KlarnaPaymentCheckout',
  slot: 'CheckoutContainer',
  styles: ({ theme }) => ({
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  }),
});

export const BackButton = superstyled({
  tag: Button,
  name: 'KlarnaPaymentCheckout',
  slot: 'BackButton',
  styles: {
    alignSelf: 'flex-start',
  },
});
